import { URLS } from 'api/constants';
import { IStreamer, IStreamerCollection } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

export async function getStreamerById(id?: string) {
  const data = await apiGetSafe<IStreamer & PaginationResponse<IStreamer>>(
    `${URLS.STREAMERS}${id ?? ''}`
  );

  if (!data) {
    return null;
  }

  if ('results' in data && Array.isArray(data.results)) {
    return (data.results[0] ?? null) as IStreamer | null;
  }

  return (data as IStreamer) ?? null;
}

export async function listStreamers({
  page,
  socials,
  limit,
  sortBy,
}: PaginationRequest & { socials?: string } = {}) {
  const data = await apiGet<PaginationResponse<IStreamer>>(URLS.STREAMERS, {
    page,
    limit,
    socials,
    sortBy,
  });

  return {
    streamers: data.results ?? [],
    count: Number(data.count ?? data.results?.length ?? 0),
  };
}

export async function listLatestStreamerReviews() {
  const data = await apiGet<PaginationResponse<IStreamerCollection>>(
    URLS.STREAMERS_LATEST_REVIEWS
  );

  return {
    reviews: data.results ?? [],
    count: Number(data.count ?? data.results?.length ?? 0),
  };
}

export async function listStreamerLanguages() {
  const data = await apiGet<PaginationResponse<string>>(
    URLS.STREAMERS_LANGUAGES
  );

  return { languages: data.results ?? [] };
}
